import { Country } from "src/externalComponents/models";
import { IAppConfiguration } from "../cemexng2components/components/app-configuration";

export default [
  {
    feature: "financial-document-detail.preview-invoice-detail",
    country: ["FR"],
  },
  {
    feature: "financial-document-detail.pricing-summary-detail",
    country: [
      "MX",
      "US",
      "CO",
      "GB",
      "DE",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "CZ",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "PL",
      "AE",
      "EG",
    ],
  },
  {
    feature: "financial-documents.ticket-delivery-default-note",
    country: ["MX", "US", "CO", "GB", "DE", "PA", "CR", "NI", "SV", "CZ", "GT", "DO", "PR", "PE", "IL", "PH", "PL"],
  },
  {
    feature: "financial-documents.ticket-delivery-sp-note",
    country: ["ES", "LV"],
  },
  {
    feature: "financial-documents.detail-purchase_order",
    excludes: { country: ["SE", "NO"] },
  },
  {
    feature: "financial-documents.detail-contract",
    excludes: { country: ["SE", "NO"] },
  },
  {
    feature: "balance-and-movements-access",
    country: ["MX"],
  },
  {
    feature: "financial-documents.delivery-ticket-detail",
    country: [
      "MX",
      "US",
      "CO",
      "GB",
      "DE",
      "PA",
      "CR",
      "NI",
      "SV",
      "CZ",
      "ES",
      "LV",
      "GT",
      "DO",
      "PR",
      "PE",
      "IL",
      "PH",
      "PL",
    ],
  },
  {
    feature: "financial-documents.detail-remaining-price",
    country: [
      "MX",
      "US",
      "CO",
      "GB",
      "DE",
      "PA",
      "CR",
      "NI",
      "SV",
      "CZ",
      "ES",
      "LV",
      "GT",
      "DO",
      "PR",
      "PE",
      "IL",
      "PH",
      "PL",
      "EG",
    ],
  },
  {
    feature: "financial-documents.amountDue",
    country: [
      "MX",
      "US",
      "CO",
      "GB",
      "DE",
      "PA",
      "CR",
      "NI",
      "SV",
      "CZ",
      "ES",
      "LV",
      "GT",
      "DO",
      "PR",
      "PE",
      "IL",
      "PH",
      "PL",
      "EG",
    ],
  },
  {
    feature: "financial-documents.table_external_delivery",
    country: [
      "MX",
      "US",
      "CO",
      "GB",
      "DE",
      "PA",
      "CR",
      "NI",
      "SV",
      "CZ",
      "ES",
      "GT",
      "DO",
      "PR",
      "PE",
      "IL",
      "PH",
      "PL",
      "AE",
      "EG",
    ],
  },
  {
    feature: "financial-documents.delivery-date-ticket",
    country: ["FR"],
  },
  {
    feature: "financial-documents.delivery-lifex",
    country: ["FR", "HR", "LV"],
  },
  {
    feature: "financial-documents.footer-btns",
    country: ["EG", "CZ"],
  },
  {
    feature: "financial-documents.unit-price",
    country: ["US", "DE", "ES", "PL", "EG", "AE", "CZ", "IL"],
  },
  {
    feature: "financial-documents.unit-price-tax",
    country: ["MX", "CO", "GB", "PA", "CR", "NI", "SV", "GT", "DO", "PR", "PE", "PH", "LV"],
  },
  {
    feature: "financial-documents.delivery-ticket-unit-price-col",
    country: ["FR"],
  },
  {
    feature: "financial-documents.delivery-ticket-tax-col",
    country: ["FR"],
  },
  {
    feature: "financial-documents.sub-total",
    country: ["IL"],
  },
  {
    feature: "financial-documents.total-label",
    country: ["IL"],
  },
  {
    feature: "financial-documents.sub-total-label",
    country: [
      "MX",
      "US",
      "CO",
      "GB",
      "DE",
      "PA",
      "CR",
      "NI",
      "SV",
      "CZ",
      "ES",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "PL",
      "AE",
      "EG",
    ],
  },
  {
    feature: "financial-documents.ticket-price",
    country: ["US", "DE", "ES", "PL", "EG", "AE", "CZ"],
  },
  {
    feature: "financial-documents.ticket-price-tax",
    country: ["MX", "CO", "GB", "PA", "CR", "NI", "SV", "GT", "DO", "PR", "PE", "IL", "PH", "LV"],
  },
  {
    feature: "financial-documents.total-price",
    country: ["US", "DE", "EG", "AE", "CZ"],
  },
  {
    feature: "financial-documents.total-price-tax",
    country: ["MX", "CO", "GB", "PA", "CR", "NI", "ES", "LV", "SV", "GT", "DO", "PR", "PE", "IL", "PH", "PL"],
  },
  {
    feature: "financial-documents.access-log",
    country: ["DO", "CO", "PA", "CR", "NI", "GT", "PR", "SV", "PE"],
    role_any: ["ARMSTAFFARC", "ARMSTAFFDM", "ARMSTAFFSR", "ARMSTAFFSRCEMENT", "ARMSTAFFSRM", "ARMSTAFFSRMCEMENT"],
  },
  {
    feature: "financial-documents-detail.access-log",
    country: ["DO", "CO", "PA", "CR", "NI", "GT", "PR", "SV", "PE"],
  },
  {
    feature: "document-detail.reference-number",
    country: [
      "MX",
      "CO",
      "GB",
      "DE",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "GT",
      "DO",
      "PR",
      "PE",
      "IL",
      "PH",
      "PL",
      "AE",
      "EG",
      "FR",
      "CZ",
    ],
  },
  {
    feature: "document-detail.document-code",
    country: [
      "MX",
      "US",
      "CO",
      "GB",
      "DE",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "GT",
      "DO",
      "PR",
      "PE",
      "IL",
      "PH",
      "PL",
      "AE",
      "EG",
    ],
  },
  {
    feature: "financial-documents.detail-ncf",
    country: ["DO", "GT"],
  },
  {
    feature: "financial-documents.related-document",
    country: ["US"],
  },
  {
    feature: "financial-documents.prompt-payment-discount",
    country: ["MX"],
  },
  {
    feature: "financial-documents.reconcile",
    country: ["MX", "CO", "PA", "CR", "NI", "SA", "PE", "IL", "GT", "DO", "PR", "PH", "AE"],
    role_match: "ARMORGreconcile",
  },
  {
    feature: "financial-documents.reconcile-same-jobsite",
    country: ["NI", "PH"],
  },
  {
    feature: "financial-documents.disclaimer",
    country: ["ES", "LV"],
    options: {
      header: "views.disclaimer.disclaimer_header",
      body: "views.disclaimer.disclaimer_body",
    },
  },
  {
    feature: "financial-documents.disclaimer",
    country: ["PL"],
    options: {
      body: "views.financial-documents.disclaimer-body",
    },
  },
  {
    feature: "financial-documents.document-type-sap",
    environment: "Quality",
  },
  {
    feature: "financial-documents.debug-columns",
    environment: "Quality",
  },
  {
    feature: "financial-documents.enabled-search-toolbar",
  },
  {
    feature: "financial-documents.enabled-checkbox-filter",
  },
  {
    feature: "financial-documents.reconcile.rate-taxes-definition",
    country: ["MX"],
    options: {
      rules: [
        {
          debitTypeCode: "RV",
          debitTaxRate: 16,
          creditTypeCode: "RV",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 16,
          creditTypeCode: "RV",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 16,
          creditTypeCode: "X0",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 16,
          creditTypeCode: "X0",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 16,
          creditTypeCode: "DA",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 16,
          creditTypeCode: "X6",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 16,
          creditTypeCode: "DG",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 16,
          creditTypeCode: "X7",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 16,
          creditTypeCode: "RV",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 16,
          creditTypeCode: "RV",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 16,
          creditTypeCode: "X0",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 16,
          creditTypeCode: "X0",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 16,
          creditTypeCode: "DA",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 16,
          creditTypeCode: "X6",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 16,
          creditTypeCode: "DG",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 16,
          creditTypeCode: "X7",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 8,
          creditTypeCode: "RV",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 8,
          creditTypeCode: "RV",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 8,
          creditTypeCode: "X0",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 8,
          creditTypeCode: "X0",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 8,
          creditTypeCode: "DA",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 8,
          creditTypeCode: "X6",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 8,
          creditTypeCode: "DG",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "RV",
          debitTaxRate: 8,
          creditTypeCode: "X7",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 8,
          creditTypeCode: "RV",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 8,
          creditTypeCode: "RV",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 8,
          creditTypeCode: "X0",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 8,
          creditTypeCode: "X0",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 8,
          creditTypeCode: "DA",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 8,
          creditTypeCode: "X6",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 8,
          creditTypeCode: "DG",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "X0",
          debitTaxRate: 8,
          creditTypeCode: "X7",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "DA",
          debitTaxRate: 16,
          creditTypeCode: "RV",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "DA",
          debitTaxRate: 16,
          creditTypeCode: "X0",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "DA",
          debitTaxRate: 8,
          creditTypeCode: "RV",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "DA",
          debitTaxRate: 8,
          creditTypeCode: "X0",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "X6",
          debitTaxRate: 16,
          creditTypeCode: "RV",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "X6",
          debitTaxRate: 16,
          creditTypeCode: "X0",
          creditTaxRate: 16,
        },
        {
          debitTypeCode: "X6",
          debitTaxRate: 8,
          creditTypeCode: "RV",
          creditTaxRate: 8,
        },
        {
          debitTypeCode: "X6",
          debitTaxRate: 8,
          creditTypeCode: "X0",
          creditTaxRate: 8,
        },
      ],
    },
  },
  {
    feature: "financial-documents.enabled-plus-icon-on-credit",
    country: ["IL"],
  },
  {
    feature: "financial-documents.mobile_downloads",
    country: [
      "MX",
      "US",
      "CO",
      "GB",
      "DE",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "CZ",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "PL",
      "AE",
      "EG",
      "FR",
    ],
  },
  {
    feature: "financial-documents.mobile_downloads_dc_report",
    country: [
      // 'MX',
      // 'US',
      // 'CO',
      // 'GB',
      // 'DE',
      // 'PA',
      // 'CR',
      // 'NI',
      // 'SV',
      // 'ES',
      // 'LV',
      // 'CZ',
      // 'GT',
      // 'DO',
      // 'PR',
      // 'PE',
      // 'PH',
      // 'PL',
      // 'AE',
      // 'EG',
      // 'FR',
    ],
  },
  {
    feature: "financial-documents.mobile_downloads_excel",
    country: [
      "MX",
      "US",
      "CO",
      "GB",
      "DE",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "CZ",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "PL",
      "AE",
      "EG",
      "FR",
    ],
  },
  {
    feature: "financial-documents.mobile_merged_documents",
    country: [
      "MX",
      "US",
      "CO",
      "GB",
      "DE",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "CZ",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "PL",
      "AE",
      "EG",
      "FR",
    ],
  },
  {
    feature: "financial-documents.statusCreditMemo",
    country: ["IL"],
  },
  {
    feature: "financial-documents.managementFeesSummary",
    country: ["IL"],
  },
  {
    feature: "financial-documents.reconcile.invalid-companies",
    country: ["MX"],
    options: ["7150", "7544"],
  },
  /**
   * @feature financial-documents.payment-regular.invalid-companies
   * @description Defines a list of companies that are not allowed to make regular payments.
   * @country CO
   * @options List of invalid company codes.
   * @see CX023GO2003-4892 - Add 7283 as an invalid company for regular payments.
   */
  {
    feature: "financial-documents.reconcile.invalid-companies",
    country: ["CO"],
    options: ["7442"],
  },

  /**
   * @feature financial-documents.payment-regular.invalid-companies
   * @description Defines a list of companies that are not allowed to make regular payments.
   * @country MX
   * @options List of invalid company codes.
   * @see DCM021CX0118-30145 - Add 7283 as an invalid company for regular payments.
   */
  {
    feature: "financial-documents.payment-regular.invalid-companies",
    country: ["MX"],
    options: ["7146", "7283"],
  },
  /**
   * @feature financial-documents.payment-regular.invalid-companies
   * @description Defines a list of companies that are not allowed to make regular payments.
   * @country CO
   * @options List of invalid company codes.
   * @see CX023GO2003-4892 - Add 7283 as an invalid company for regular payments.
   */
  {
    feature: "financial-documents.payment-regular.invalid-companies",
    country: ["CO"],
    options: ["7442"],
  },
  {
    feature: "financial-documents.download-invoice.aditional-documents",
    country: ["MX"],
    options: [
      {
        documentType: "01",
        addtionalDocuments: "32",
      },
    ],
  },
  {
    feature: "financial-documents.hide-calendar-view",
    country: ["US"],
    role: "ARMSTAFFMANCRED",
  },
  {
    feature: "financial-documents.hide-disputes",
    country: ["US"],
    role: "ARMSTAFFMANCRED",
  },
  {
    feature: "financial-documents.hide-disputes",
    country: ["CO","DO"]
  },
  {
    feature: "financial-documents.internal-users-staff",
    country: ["US"],
    role: "ARMSTAFFMANCRED",
  },
  {
    feature: "financial-documents.document-center-report",
    country: ["DO","CO"]
  },
] as IAppConfiguration[];
